import { render } from "./NavTopBar.vue?vue&type=template&id=5789e3c6&scoped=true"
import script from "./NavTopBar.vue?vue&type=script&lang=js"
export * from "./NavTopBar.vue?vue&type=script&lang=js"

import "./NavTopBar.vue?vue&type=style&index=0&id=5789e3c6&lang=scss&scoped=true"

import exportComponent from "D:\\部署项目\\电商\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5789e3c6"]])

export default __exports__